import React from 'react'

interface ToggleChevronButtonProps {
    toggle?: boolean
    onClick(): void
}

const ToggleChevronButton: React.VFC<ToggleChevronButtonProps> = ({ toggle, onClick }) => (
    <button className="col-md-1 chevron-toggle" type="button" onClick={onClick}>
        <i className={`far fa-chevron-${toggle ? 'up' : 'down'}`} />
    </button>
)

export default ToggleChevronButton
